import { render, staticRenderFns } from "./BedbuilderFooterOptions.vue?vue&type=template&id=63593662&scoped=true&"
import script from "./BedbuilderFooterOptions.vue?vue&type=script&lang=js&"
export * from "./BedbuilderFooterOptions.vue?vue&type=script&lang=js&"
import style0 from "./BedbuilderFooterOptions.vue?vue&type=style&index=0&id=63593662&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63593662",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BedbuilderSubOptionsCard: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bedbuilder/BedbuilderSubOptionsCard.vue').default,BedbuilderUnavailableModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bedbuilder/BedbuilderUnavailableModal.vue').default,BedbuilderOptionModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bedbuilder/BedbuilderOptionModal.vue').default,BedbuilderOptionsCard: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bedbuilder/BedbuilderOptionsCard.vue').default})
